// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1zk3I","label":"LabeledBox_label__2aOXp"};